import { clickable, fillable, isPresent, text, value } from 'ember-cli-page-object';
export default (scope = '[data-test-vc-link]', properties = {}) => ({
  scope,
  isUserPass: isPresent('[data-test-form-user-pass]'),
  is2fa: isPresent('[data-test-form-2fa]'),
  isReset: isPresent('[data-test-form-reset]'),
  fillInUsername: fillable('input[name="username"]'),
  fillInPassword: fillable('input[name="password"]'),
  fillIn2fa: fillable('input[name="code"]'),
  username: value('input[name="username"]'),
  password: value('input[name="password"]'),
  code: value('input[name="code"]'),
  passwordLabel: text('label:eq(1)'),
  // This works for all three phases
  submit: clickable('button[type="submit"]'),
  recover: clickable('button.hds-button--color-tertiary'),
  ...properties
});